export const GET_DATA_ENPS_WATCHER = "app/WidgetChartEnps/GET_DATA_ENPS_WATCHER"
export const GET_DATA_ENPS_SUCCESS = "app/WidgetChartEnps/GET_DATA_ENPS_SUCCESS"
export const GET_DATA_ENPS_FAILED = "app/WidgetChartEnps/GET_DATA_ENPS_FAILED"
